<template>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm6 md4>
            <fcc-new-password />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
</template>

<script>
  import FCCNewPassword from './components/FCCNewPassword'

  export default {
    data: () => ({
      drawer: null,
    }),
    props: {
      source: String
    },
    components: {
      "fcc-new-password": FCCNewPassword
    }
  }
</script>